import { useDictionary } from 'models/dictionaryContext';
import { ActionTypes } from 'state/actions/alert';
import { ILegalEntityFormValues } from 'pages/LegalEntitiesPage/LegalEntityForm';
import { useAlert } from 'models/alertContext';
import {
  activateIndividualLegalEntity,
  activateOrganizationLegalEntity,
  addAncillariesToGroup,
  assignLE,
  createLegalEntity,
  createLegalEntityAddress,
  createLegalEntityAncillaryGroup,
  createLegalEntityComment,
  createLegalEntityContact,
  createLegalEntityGroup,
  createLegalEntityPreviousNamesSurnames,
  createLEGroupFirearm,
  createOrgLegalEntity,
  deactivateIndividualLegalEntity,
  deactivateOrganizationLegalEntity,
  deleteAssignedLE,
  deleteLegalEntity,
  deleteLegalEntityAddress,
  deleteLegalEntityAncillariesGroup,
  deleteLegalEntityContact,
  deleteLegalEntityGroup,
  deleteLegalEntityPreviousNamesSurnames,
  deleteOrgLegalEntity,
  getLegalEntities,
  getLegalEntity,
  getLegalEntityAddressDetail,
  getLegalEntityAddresses,
  getLegalEntityAncillaries,
  getLegalEntityAncillaryGroup,
  getLegalEntityAncillaryGroupAncillaries,
  getLegalEntityAncillaryGroupTransactionType,
  getLegalEntityComments,
  getLegalEntityContacts,
  getLegalEntityFirearms,
  getLegalEntityGroup,
  getLegalEntityGroupFirearms,
  getLegalEntityGroups,
  getLegalEntityLatestContact,
  getLegalEntityLicenceAuthorities,
  getLegalEntityLicenceDetails,
  getLegalEntityLicences,
  getLegalEntityPreviousNamesSurnames,
  getLegalEntityPreviousNamesSurnamesDetail,
  getLegalEntityStorageAddresses,
  getLicenceHasSuspendedParent,
  getLicenceMismatchingLegalEntity,
  getOrgLegalEntity,
  ISearchParams,
  removeLEGroupAncillary,
  removeLEGroupFirearm,
  searchLegalAttachments,
  searchLocationCoordsByAddress,
  transactionAncillaryGroupTypeValidate,
  updateLegalEntity,
  updateLegalEntityAddress,
  updateLegalEntityAncillaryGroup,
  updateLegalEntityContact,
  updateLegalEntityGroup,
  updateLegalEntityPreviousNamesSurnames,
  updateOrgLegalEntity,
} from 'requests/legalEntities';
import { useCallback, useState } from 'react';
import {
  ELegalAttachmentsGroupBy,
  IAssignLE,
  IFormActivationLEValues,
  IFormDeactivationLEValues,
  ILegalAttachmentItem,
  ILegalEntity,
  ILegalEntityAddressDetail,
  ILegalEntityAncillaries,
  ILegalEntityAncillaryGroup,
  ILegalEntityAncillaryGroupAncillaries,
  ILegalEntityContact,
  ILegalEntityContactSimple,
  ILegalEntityContactWithAssociation,
  ILegalEntityExtendedAddress,
  ILegalEntityFirearm,
  ILegalEntityGroup,
  ILegalEntityGroupResponse,
  ILegalEntityLicence,
  ILegalEntityLicenceAuthorityResponse,
  ILegalEntityLicenceDetails,
  ILegalEntityLicenceFormValues,
  ILegalEntityLicenceMismatching,
  ILegalEntityLicenceRenewFormValues,
  ILegalEntityLicenceVaryFormValues,
  ILegalEntityPreviousNamesSurnames,
  ILicenceSearchForLeParameters,
  ITransactionType,
} from 'models/legalEntity';
import { IPaginator } from 'models/paginator';
import { EPerPages, ISortOptions } from 'models/table';
import { getOrganizationLegalEntities } from 'requests/organizationLegalEntites';
import { IOrganizationLegalEntity } from 'models/organizationLegalEntity';
import { ERouteLinks } from 'models/route';
import { useMatch, useNavigate, useParams } from 'react-router-dom';
import { useQuery } from 'hooks/useQuery';
import { IOrgLegalEntityFormValues } from 'pages/LegalEntitiesPage/OrgLegalEntityForm';
import {
  ISearchFormILEValues,
  ISearchFormValues as ISearchFormOLEValues,
} from 'pages/LegalEntitiesPage/OrganisationSearchForm';
import { ILegalEntityAddressFormValues } from 'pages/LegalEntitiesPage/LegalEntityAddressForm';
import { ILegalEntityContactFormValues } from 'pages/LegalEntitiesPage/LegalEntityContactForm';
import { ILegalEntityCommentData } from 'pages/LegalEntitiesPage/LegalEntityDeleteCommentPage';
import {
  IFormElementOptionProp,
  ILegalEntityAncillaryGroupFormValues,
  ILegalEntityEditGroupFormValues,
  ILegalEntityGroupFormValues,
  ISearchFirearmFormValues,
  ISearchGroupFormValues,
  ISearchLegalAttachmentsFormValues,
  ISearchLegalEntityAncillariesFormValues,
  ISearchLegalEntityAncillaryGroupFormValues,
} from 'models/form';
import { deleteComment } from 'requests/comment';
import { ICommentFormValues } from 'components/organisms/CommentForm';
import { createInitialTransaction } from 'requests/transaction';
import { IInitialTransaction } from 'models/transaction';
import { useTranslations } from 'hooks/useTranslations';
import { ESelectLE } from 'pages/Firearms/RegisteredFirearmsSearchForm';
import { EDictionaryTypes } from 'models/dictionary';
import { ECustomFieldObjectType, ICustomFieldByObjectType } from 'models/customField';
import { getCustomFieldByObjectType } from 'requests/customField';
import { EAlertVariants } from 'components/atoms/Alert';
import {
  ILegalEntityWeaponLicence,
  ILegalEntityWeaponLicenceRenew,
  ILegalEntityWeaponLicenceVary,
  ILicenceActionRequest,
  ILicenceAttachmentsResponse,
  ILicenceHistoryResponse,
  ILicenceScheduledResponse,
  ILicenceUpdatePaymentStatusRequest,
  IOwner,
} from 'models/licence';
import { getAncillariesFromGroup, getAncillariesGroupDetail } from 'requests/ancillaries';
import { IAncillary } from 'models/ancillaries';
import { formatOnlyDateToRequest } from 'utils/date';
import { ILicenceTemplateForLe } from 'models/licenceConfigurator';
import { getLicenceTemplatesForLE } from 'requests/licenceConfigurator';
import {
  cancelWeaponLicence,
  createWeaponLicence,
  getLicenceAttachmentFileData,
  getLicenceAttachments,
  getLicenceHistory,
  reactivateWeaponLicence,
  renewWeaponLicence,
  revokeWeaponLicence,
  surrenderWeaponLicence,
  suspendWeaponLicence,
  varyWeaponLicence,
  weaponLicenceScheduledData,
} from 'requests/licence';
import { ILicenceFirearmsResponse } from 'models/licencesFirearms';
import { getLicenceWeapon } from 'requests/licencesFirearms';
import { ILegalEntityPreviousNamesSurnamesFormValues } from './LegalEntityPreviousNamesSurnamesForm';
import { ELegalEntityTypes } from 'constants/LegalEntityTypes';
import { ICaseForLe, ICaseSearchForLe } from 'models/cases';
import { getLegalEntityCases } from 'requests/case';

export const useLegalEntities = () => {
  const { t } = useTranslations();
  const [legalEntities, setLegalEntities] = useState<ILegalEntity[]>([]);
  const [legalEntityFirearms, setLegalEntityFirearms] = useState<ILegalEntityFirearm[]>([]);
  const [legalEntityGroupFirearms, setLegalEntityGroupFirearms] = useState<
    ILegalEntityFirearm[]
  >([]);
  const [legalEntityGroups, setLegalEntityGroups] = useState<ILegalEntityGroup[]>([]);
  const [organizationLegalEntity, setOrganizationLegalEntity] = useState<
    IOrganizationLegalEntity[]
  >([]);
  const [legalEntityAncillaries, setLegalEntityAncillaries] = useState<
    ILegalEntityAncillaries[]
  >([]);
  const [legalEntityAncillaryGroups, setLegalEntityAncillaryGroups] = useState<
    ILegalEntityAncillaryGroup[]
  >([]);
  const [ancillaryGroupDetail, setAncillaryGroupDetail] =
    useState<ILegalEntityAncillaryGroup | null>(null);
  const [legalEntityAncillaryGroupAncillaries, setLegalEntityAncillaryGroupAncillaries] =
    useState<IAncillary[]>([]);
  const [paginatorAncillaryGroupAncillaries, setPaginatorAncillaryGroupAncillaries] =
    useState<IPaginator | null>(null);
  const [paginatorILE, setPaginatorILE] = useState<IPaginator | null>(null);
  const [legalEntityAddress, setLegalEntityAddress] = useState<ILegalEntityExtendedAddress[]>(
    [],
  );
  const [legalEntityAddressDetails, setLegalEntityAddressDetails] =
    useState<ILegalEntityAddressDetail>();
  const [legalEntityLicences, setLegalEntityLicences] = useState<ILegalEntityLicence[]>([]);
  const [paginatorLicences, setPaginatorLicences] = useState<IPaginator | null>(null);
  const [legalEntityLicenceDetails, setLegalEntityLicenceDetails] =
    useState<ILegalEntityLicenceDetails | null>(null);
  const [licenceHasSuspendedParent, setLicenceHasSuspendedParent] = useState<
    boolean | undefined | null
  >(undefined);
  const [licenceMismatchingLegalEntity, setLicenceMismatchingLegalEntity] =
    useState<ILegalEntityLicenceMismatching | null>(null);
  const [licenceAttachments, setLicenceAttachments] =
    useState<ILicenceAttachmentsResponse | null>(null);
  const [licenceHistory, setLicenceHistory] = useState<ILicenceHistoryResponse | null>(null);
  const [licenceWeapon, setLicenceWeapon] = useState<ILicenceFirearmsResponse[]>([]);
  const [legalEntityStorageAddress, setLegalEntityStorageAddress] = useState<
    ILegalEntityExtendedAddress[]
  >([]);
  const [legalEntityStorageAddressLoaded, setLegalEntityStorageAddressLoaded] =
    useState(false);
  const [paginatorOLE, setPaginatorOLE] = useState<IPaginator | null>(null);
  const [paginatorLEF, setPaginatorLEF] = useState<IPaginator | null>(null);
  const [paginatorLicenceTemplateLE, setPaginatorLicenceTemplateLE] =
    useState<IPaginator | null>(null);
  const [paginatorLEG, setPaginatorLEG] = useState<IPaginator | null>(null);
  const [paginatorLEGF, setPaginatorLEGF] = useState<IPaginator | null>(null);
  const [paginatorAncillaries, setPaginatorAncillaries] = useState<IPaginator | null>(null);
  const [paginatorAncillaryGroups, setPaginatorAncillaryGroups] = useState<IPaginator | null>(
    null,
  );
  const [legalEntityAttachments, setLegalEntityAttachments] = useState<
    ILegalAttachmentItem[] | Record<string, ILegalAttachmentItem[]>
  >([]);
  const [paginatorLegalAttachments, setPaginatorLegalAttachments] =
    useState<IPaginator | null>(null);
  const [legalEntityContacts, setLegalEntityContacts] = useState<
    ILegalEntityContactWithAssociation[]
  >([]);
  const [legalEntityPreviousNamesSurnames, setLegalEntityPreviousNamesSurnames] = useState<
    ILegalEntityPreviousNamesSurnames[]
  >([]);
  const [legalEntityPreviousNamesSurnamesDetail, setLegalEntityPreviousNamesSurnamesDetail] =
    useState<ILegalEntityPreviousNamesSurnames>();
  const [legalEntityLatestContact, setLegalEntityLatestContact] = useState<
    ILegalEntityContactSimple | null | undefined
  >(undefined);
  const [legalEntityComments, setLegalEntityComments] = useState<ILegalEntityCommentData[]>(
    [],
  );
  const [paginatorLEComments, setPaginatorLEComments] = useState<IPaginator | null>(null);
  const [legalEntityGroup, setLegalEntityGroup] = useState<ILegalEntityGroupResponse | null>(
    null,
  );

  const [keeper, setKeeper] = useState<IFormElementOptionProp>();
  const [owner, setOwner] = useState<IFormElementOptionProp>();

  const [customFieldsILE, setCustomFieldsILE] = useState<ICustomFieldByObjectType[]>([]);
  const [customFieldsOLE, setCustomFieldsOLE] = useState<ICustomFieldByObjectType[]>([]);
  const [customFieldsFirearms, setCustomFieldsFirearms] = useState<ICustomFieldByObjectType[]>(
    [],
  );
  const [customFieldsAncillaries, setCustomFieldsAncillaries] = useState<
    ICustomFieldByObjectType[]
  >([]);
  const [customFieldsLicence, setCustomFieldsLicence] = useState<ICustomFieldByObjectType[]>(
    [],
  );
  const [customFieldsLoaded, setCustomFieldsLoaded] = useState(false);
  const [ancillaryGrouptransactionType, setAncillaryGrouptransactionType] = useState<
    ITransactionType[]
  >([]);
  const [ancillariesDetail, setAncillariesDetail] =
    useState<ILegalEntityAncillaryGroupAncillaries | null>(null);
  const [transactionTypeIsValid, setTransactionTypeIsValid] = useState<boolean>(true);
  const [licencesTemplatesForLE, setLicencesTemplatesForLE] =
    useState<ILicenceTemplateForLe[]>();

  const [legalEntityLicenceAuthorities, setLegalEntityLicenceAuthorities] = useState<
    ILegalEntityLicenceAuthorityResponse | undefined | null
  >(undefined);

  const [legalEntityCases, setLegalEntityCases] = useState<ICaseForLe[]>([]);
  const [paginatorCases, setPaginatorCases] = useState<IPaginator | null>(null);

  const query = useQuery();
  const type: string | null = query.get('type')?.trim() || null;
  const expand: any = query.get('expand');
  const {
    gender,
    getGender,
    getOrganisationStateType,
    organisationStateType,
    getOrganisationCivilianType,
    organisationCivilianType,
    getOrganisationMilitaryType,
    organisationMilitaryType,
    getOrganisationPoliceType,
    organisationPoliceType,
    organisationCategory,
    getOrganisationCategory,
    legalVisibility,
    getLegalVisibility,
    legalEntityPrefix,
    getLegalEntityPrefix,
    civilianPrefix,
    getCivilianPrefix,
    militaryPrefix,
    getMilitaryPrefix,
    policePrefix,
    getPolicePrefix,
    make,
    getMake,
    model,
    getModel,
    state,
    getState,
    caliber,
    getCaliber,
    region,
    getRegion,
    country,
    getCountry,
    manufacturerCountry,
    getManufacturerCountry,
    phoneCode,
    getPhoneCode,
    addressType,
    getAddressType,
    legality,
    getLegality,
    manufacturer,
    getManufacturer,
    level,
    firearmAction,
    getFirearmAction,
    firearmType,
    getFirearmType,
    transactionType,
    getTransactionType,
    legalClassification,
    countryAll,
    getCountryAll,
    artAncillaryOptions,
    getArtAncillaryOptions,
    artComponentType,
    getArtComponentType,
    artAccessoryType,
    getArtAccessoryType,
    artAmmunitionType,
    getArtAmmunitionType,
    artAccessoryManufacturerFlashEliminator,
    getArtAccessoryManufacturerFlashEliminator,
    artAccessoryManufacturerLaserLightModule,
    getArtAccessoryManufacturerLaserLightModule,
    artAccessoryManufacturerMagazine,
    getArtAccessoryManufacturerMagazine,
    artAccessoryManufacturerOpticalSight,
    getArtAccessoryManufacturerOpticalSight,
    artAccessoryManufacturerSuppressor,
    getArtAccessoryManufacturerSuppressor,
    artAmmunitionManufacturer,
    getArtAmmunitionManufacturer,
    artComponentManufacturer,
    getArtComponentManufacturer,
    weaponLicencingAuthority,
    getWeaponLicencingAuthority,
    nationality,
    getNationality,
    identificationDocumentType,
    getIdentificationDocumentType,
    getLegalStatus,
    legalStatus,
    getLegalIndividualDeactivationReason,
    legalIndividualDeactivationReason,
    getLegalOrganisationDeactivationReason,
    legalOrganisationDeactivationReason,
  } = useDictionary();
  const { setAlert } = useAlert();
  const navigate = useNavigate();
  const { id: leUniqueId = '' } = useParams<{ id: string }>();

  const isFirearmGroupPage = useMatch(ERouteLinks.LegalEntityGroupDeleteFirearm);
  const isAncillaryGroupPage = useMatch(ERouteLinks.LegalEntityGroupDeleteAncillary);

  const { groupId: firearmGroupId = '' } = useParams<{ groupId: string }>();
  const { groupId: ancillaryGroupId = '' } = useParams<{ groupId: string }>();

  const loadDictionaries = async (types: EDictionaryTypes[]) => {
    if (types.includes(EDictionaryTypes.Gender)) getGender();

    if (types.includes(EDictionaryTypes.OrganisationStateType)) getOrganisationStateType();

    if (types.includes(EDictionaryTypes.OrganisationCivilianType))
      getOrganisationCivilianType();

    if (types.includes(EDictionaryTypes.OrganisationMilitaryType))
      getOrganisationMilitaryType();

    if (types.includes(EDictionaryTypes.OrganisationPoliceType)) getOrganisationPoliceType();

    if (types.includes(EDictionaryTypes.OrganisationCategory)) getOrganisationCategory();

    if (types.includes(EDictionaryTypes.LegalVisibility)) getLegalVisibility();

    if (types.includes(EDictionaryTypes.legalEntityPrefix)) getLegalEntityPrefix();

    if (types.includes(EDictionaryTypes.civilianPrefix)) getCivilianPrefix();

    if (types.includes(EDictionaryTypes.militaryPrefix)) getMilitaryPrefix();

    if (types.includes(EDictionaryTypes.policePrefix)) getPolicePrefix();

    if (types.includes(EDictionaryTypes.Region)) getRegion();

    if (types.includes(EDictionaryTypes.Country)) getCountry();

    if (types.includes(EDictionaryTypes.ManufacturerCountry)) getManufacturerCountry();

    if (types.includes(EDictionaryTypes.PhoneCode)) getPhoneCode();

    if (types.includes(EDictionaryTypes.AddressType)) getAddressType();

    if (types.includes(EDictionaryTypes.Legality)) getLegality();

    if (types.includes(EDictionaryTypes.Manufacturer)) getManufacturer();

    if (types.includes(EDictionaryTypes.FirearmAction)) getFirearmAction();

    if (types.includes(EDictionaryTypes.FirearmType)) getFirearmType();

    if (types.includes(EDictionaryTypes.TransactionType)) getTransactionType();

    if (types.includes(EDictionaryTypes.Make)) getMake();

    if (types.includes(EDictionaryTypes.Model)) getModel();

    if (types.includes(EDictionaryTypes.State)) getState();

    if (types.includes(EDictionaryTypes.Caliber)) getCaliber();

    if (types.includes(EDictionaryTypes.AddressType)) getAddressType();

    if (types.includes(EDictionaryTypes.CountryAll)) getCountryAll();

    if (types.includes(EDictionaryTypes.ArtAncillaryOptions)) getArtAncillaryOptions();

    if (types.includes(EDictionaryTypes.ArtAccessoryType)) getArtAccessoryType();

    if (types.includes(EDictionaryTypes.ArtAmmunitionType)) getArtAmmunitionType();

    if (types.includes(EDictionaryTypes.ArtComponentType)) getArtComponentType();

    if (types.includes(EDictionaryTypes.ArtAccessoryManufacturerFlashEliminator))
      getArtAccessoryManufacturerFlashEliminator();

    if (types.includes(EDictionaryTypes.ArtAccessoryManufacturerLaserLightModule))
      getArtAccessoryManufacturerLaserLightModule();

    if (types.includes(EDictionaryTypes.ArtAccessoryManufacturerMagazine))
      getArtAccessoryManufacturerMagazine();

    if (types.includes(EDictionaryTypes.ArtAccessoryManufacturerOpticalSight))
      getArtAccessoryManufacturerOpticalSight();

    if (types.includes(EDictionaryTypes.ArtAccessoryManufacturerSuppressor))
      getArtAccessoryManufacturerSuppressor();

    if (types.includes(EDictionaryTypes.ArtAmmunitionManufacturer))
      getArtAmmunitionManufacturer();

    if (types.includes(EDictionaryTypes.ArtComponentManufacturer))
      getArtComponentManufacturer();

    if (types.includes(EDictionaryTypes.weaponLicencingAuthority))
      getWeaponLicencingAuthority();

    if (types.includes(EDictionaryTypes.nationality)) getNationality();

    if (types.includes(EDictionaryTypes.nationality)) getIdentificationDocumentType();

    if (types.includes(EDictionaryTypes.legalStatus)) getLegalStatus();
    if (types.includes(EDictionaryTypes.legalIndividualDeactivationReason))
      getLegalIndividualDeactivationReason();
    if (types.includes(EDictionaryTypes.legalOrganisationDeactivationReason))
      getLegalOrganisationDeactivationReason();
  };

  const getAncillaryGrouptransactionType = async (groupId: string, legalType: string) => {
    const legalEntityGroupData = await getLegalEntityAncillaryGroupTransactionType(
      groupId,
      legalType,
    );
    if (legalEntityGroupData) {
      setAncillaryGrouptransactionType(legalEntityGroupData);
    } else {
      setAncillaryGrouptransactionType([]);
    }
  };

  const transactionTypeValidate = async (groupId: string, typeUniqeId: string) => {
    const response = await transactionAncillaryGroupTypeValidate(groupId, typeUniqeId);
    if (response && response.length) {
      setTransactionTypeIsValid(false);
      setAlert(ActionTypes.SET_SAME_PAGE_ALERT, {
        text: `${t('addTransaction.transactionType.valid')} ${response.join(', ')}.`,
        variant: EAlertVariants.error,
      });
    } else {
      setTransactionTypeIsValid(true);
    }
  };

  const handleCreate = async (data: ILegalEntityFormValues) => {
    try {
      data.dateOfBirth = formatOnlyDateToRequest(data.dateOfBirth);
      const response = await createLegalEntity(data);

      if (response) {
        setAlert(ActionTypes.SET_LEGAL_ENTITY_ALERT, {
          text: t('addLegalEntity.save.success.text'),
        });
      }

      return response;
    } catch (e: any) {
      setAlert(ActionTypes.SET_SAME_PAGE_ALERT, {
        text: e.response.data?.errors?.[0]?.message || e.response.data?.message,
        variant: EAlertVariants.error,
      });
      return false;
    }
  };

  const handleEdit = async (legalEntity: ILegalEntityFormValues) => {
    try {
      legalEntity.dateOfBirth = formatOnlyDateToRequest(legalEntity.dateOfBirth);
      const response = await updateLegalEntity(legalEntity);
      if (response) {
        setAlert(ActionTypes.SET_LEGAL_ENTITY_ALERT, {
          text: t('editLegalEntity.save.success.info'),
        });
      }
      return response;
    } catch (e: any) {
      setAlert(ActionTypes.SET_SAME_PAGE_ALERT, {
        text: e.response.data?.errors?.[0]?.message || e.response.data?.message,
        variant: EAlertVariants.error,
      });
      return false;
    }
  };

  const handleDelete = async (id: string) => {
    const response = await deleteLegalEntity(id);
    if (response) {
      await setAlert(ActionTypes.SET_LEGAL_ENTITY_ALERT, {
        text: t('deleteLegalEntity.save.success.text'),
      });
    }
    return response;
  };

  const getLegalEntitiesData = async (
    currentPage: number,
    perPage: EPerPages,
    sort: ISortOptions | null,
    queryILE: Partial<ISearchFormILEValues>,
  ) => {
    const legalEntitiesData = await getLegalEntities(currentPage, perPage, sort, queryILE);
    if (legalEntitiesData) {
      const { content, ...paginatorData } = legalEntitiesData;
      setLegalEntities(content);
      setPaginatorILE(paginatorData);
      return legalEntitiesData.content;
    }
    setLegalEntities([]);
    setPaginatorILE(null);
    return [];
  };

  const getLegalEntityFirearmsData = async (
    currentPage: number = 1,
    perPage: EPerPages = EPerPages.perPage25,
    firearmQuery: Partial<ISearchFirearmFormValues> = {},
    firearmSort?: ISortOptions | null,
  ) => {
    const legalEntityFirearmsData = await getLegalEntityFirearms(
      currentPage,
      perPage,
      firearmQuery,
      firearmSort,
    );
    if (legalEntityFirearmsData) {
      const { content, ...paginatorData } = legalEntityFirearmsData;
      setLegalEntityFirearms(content);
      setPaginatorLEF(paginatorData);
    } else {
      setLegalEntityFirearms([]);
      setPaginatorLEF(null);
    }
  };

  const getLegalEntityAncillariesData = async (
    id: string,
    currentPage: number = 1,
    perPage: EPerPages = EPerPages.perPage25,
    ancillariesQuery: Partial<ISearchLegalEntityAncillariesFormValues> = {},
    ancillariesSort?: ISortOptions | null,
  ) => {
    const data = await getLegalEntityAncillaries(
      currentPage,
      perPage,
      { ...ancillariesQuery, legalUniqueId: id },
      ancillariesSort,
    );
    if (data) {
      const { content, ...paginatorData } = data;
      setLegalEntityAncillaries(content);
      setPaginatorAncillaries(paginatorData);
    } else {
      setLegalEntityAncillaries([]);
      setPaginatorAncillaries(null);
    }
  };

  const getLegalEntityAncillaryGroupsData = async (
    id: string,
    currentPage: number = 1,
    perPage: EPerPages = EPerPages.perPage25,
    ancillaryGroupQuery: Partial<ISearchLegalEntityAncillaryGroupFormValues> = {},
    ancillaryGroupSort?: ISortOptions | null,
  ) => {
    const data = await getLegalEntityAncillaryGroup(
      id,
      currentPage,
      perPage,
      { ...ancillaryGroupQuery },
      ancillaryGroupSort,
    );
    if (data) {
      const { content, ...paginatorData } = data;
      setLegalEntityAncillaryGroups(content);
      setPaginatorAncillaryGroups(paginatorData);
    } else {
      setLegalEntityAncillaryGroups([]);
      setPaginatorAncillaryGroups(null);
    }
  };

  const getLegalEntityAttachmentsData = useCallback(
    async (
      legalUniqueId: string,
      currentPage: number = 1,
      perPage: EPerPages = EPerPages.perPage25,
      attachmentsQuery: Partial<ISearchLegalAttachmentsFormValues> = {},
      attachmentsSort?: ISortOptions | null,
    ) => {
      const data = await searchLegalAttachments(currentPage, perPage, attachmentsSort, {
        ...attachmentsQuery,
        legalUniqueId,
      });

      if (data) {
        const { content, ...paginatorData } = data;
        if (
          attachmentsQuery.groupBy === ELegalAttachmentsGroupBy.ATTACHMENT_TYPE ||
          attachmentsQuery.groupBy === ELegalAttachmentsGroupBy.NUMBER
        ) {
          const result = Object.fromEntries(
            Object.values(content).map((item) => [item.groupKey, item.items]),
          );
          setLegalEntityAttachments(result as Record<string, ILegalAttachmentItem[]>);
        } else {
          const responseWithAll = content as { items: ILegalAttachmentItem[] }[];
          setLegalEntityAttachments(responseWithAll[0].items);
        }
        setPaginatorLegalAttachments(paginatorData);
      } else {
        setLegalEntityAttachments(
          attachmentsQuery.groupBy === ELegalAttachmentsGroupBy.ATTACHMENT_TYPE ||
            attachmentsQuery.groupBy === ELegalAttachmentsGroupBy.NUMBER
            ? {}
            : [],
        );
        setPaginatorLegalAttachments(null);
      }
    },
    [],
  );

  const getLegalEntityGroupFirearmsData = async (
    leId: string,
    groupId: string,
    currentPage: number = 1,
    perPage: EPerPages = EPerPages.perPage25,
    firearmQuery: Partial<ISearchFirearmFormValues> = {},
    firearmSort?: ISortOptions | null,
  ) => {
    const legalEntityGroupFirearmsData = await getLegalEntityGroupFirearms(
      leId,
      groupId,
      currentPage,
      perPage,
      firearmQuery,
      firearmSort,
    );
    if (legalEntityGroupFirearmsData) {
      const { content, ...paginatorData } = legalEntityGroupFirearmsData;
      setLegalEntityGroupFirearms(content);
      setPaginatorLEGF(paginatorData);
    } else {
      setLegalEntityGroupFirearms([]);
      setPaginatorLEGF(null);
    }
  };

  const getOrganizationLegalEntitiesData = async (
    currentPage: number,
    perPage: EPerPages,
    sort: ISortOptions | null,
    queryOLE: Partial<ISearchFormOLEValues>,
  ) => {
    const organizationLegalEntities = await getOrganizationLegalEntities(
      currentPage,
      perPage,
      sort,
      queryOLE,
    );
    if (organizationLegalEntities) {
      const { content, ...paginatorData } = organizationLegalEntities;
      setOrganizationLegalEntity(content);
      setPaginatorOLE(paginatorData);
      return content;
    }
    setOrganizationLegalEntity([]);
    setPaginatorOLE(null);
    return [];
  };

  const getLegalEntityGroupsData = async (
    id: string,
    currentPage: number = 1,
    perPage: EPerPages = EPerPages.perPage25,
    groupQuery: Partial<ISearchGroupFormValues> = {},
    groupSort?: ISortOptions | null,
  ) => {
    const legalEntityGroupsData = await getLegalEntityGroups(
      id,
      currentPage,
      perPage,
      groupQuery,
      groupSort,
    );
    if (legalEntityGroupsData) {
      const { content, ...paginatorData } = legalEntityGroupsData;
      setLegalEntityGroups(content);
      setPaginatorLEG(paginatorData);
    } else {
      setLegalEntityGroups([]);
      setPaginatorLEG(null);
    }
  };

  const getLegalEntityGroupData = async (id: string, groupId: string) => {
    const legalEntityGroupData = await getLegalEntityGroup(id, groupId);
    if (legalEntityGroupData) {
      setLegalEntityGroup(legalEntityGroupData);
    } else {
      setLegalEntityGroup(null);
    }
  };

  const handleOrgLECreate = async (data: IOrgLegalEntityFormValues) => {
    try {
      const response = await createOrgLegalEntity(data);

      if (response) {
        setAlert(ActionTypes.SET_LEGAL_ENTITY_ORG_ALERT, {
          text: t('addLegalEntityOrg.save.success.text'),
        });
      }

      return response;
    } catch (e: any) {
      setAlert(ActionTypes.SET_SAME_PAGE_ALERT, {
        text: e.response.data?.errors?.[0]?.message || e.response.data?.message,
        variant: EAlertVariants.error,
      });
      return false;
    }
  };

  const handleOrgLEEdit = async (legalEntity: IOrgLegalEntityFormValues) => {
    try {
      const response = await updateOrgLegalEntity(legalEntity);
      if (response) {
        setAlert(ActionTypes.SET_LEGAL_ENTITY_ORG_ALERT, {
          text: t('editLegalEntity.save.success.info'),
        });
      }
      return response;
    } catch (e: any) {
      setAlert(ActionTypes.SET_SAME_PAGE_ALERT, {
        text: e.response.data?.errors?.[0]?.message || e.response.data?.message,
        variant: EAlertVariants.error,
      });
      return false;
    }
  };

  const handleOrgLEDelete = async (id: string) => {
    const response = await deleteOrgLegalEntity(id);
    if (response) {
      setAlert(ActionTypes.SET_LEGAL_ENTITY_ORG_ALERT, {
        text: t('deleteLegalEntity.save.success.text'),
      });
    }
    return response;
  };

  const getLegalEntityCommentsData = async (
    id: string,
    queryParams: {
      withHidden: boolean;
      currentPage: number;
      perPage: EPerPages;
    },
  ) => {
    const legalEntityCommentsData = await getLegalEntityComments(id, queryParams);
    if (legalEntityCommentsData) {
      const { content, ...paginatorData } = legalEntityCommentsData;

      setLegalEntityComments(content);
      setPaginatorLEComments(paginatorData);
    } else {
      setLegalEntityComments([]);
      setPaginatorLEComments(null);
    }
  };

  const handleCreateComment = async (data: ICommentFormValues) => {
    const response = await createLegalEntityComment(data);

    if (response) {
      await setAlert(ActionTypes.SET_LEGAL_ENTITY_ALERT, {
        text: t('addComment.save.success.text'),
      });
    }

    return response;
  };

  const navigateToList = () => {
    navigate(`${ERouteLinks.LegalEntities}?expand=${type}`);
  };

  const navigateToDetails = () => {
    navigate(
      `${ERouteLinks.ViewLegalEntity.replace(
        ':id',
        leUniqueId,
      )}?type=${type}&expand=${expand}`,
    );
  };

  const navigateToGroupDetails = () => {
    if (isFirearmGroupPage) {
      navigate(
        `${ERouteLinks.ViewLegalEntityGroup.replace(':id', leUniqueId).replace(
          ':groupId',
          firearmGroupId,
        )}?type=${type}&expand=${expand}`,
      );
    } else if (isAncillaryGroupPage) {
      navigate(
        `${ERouteLinks.ViewLegalEntityAncillaryGroup.replace(':id', leUniqueId).replace(
          ':groupId',
          ancillaryGroupId,
        )}?type=${type}&expand=${expand}`,
      );
    }
  };

  const handleDeleteComment = async (id: string, isHidden: any) => {
    const response = await deleteComment(id, isHidden);
    if (response) {
      await setAlert(ActionTypes.SET_LEGAL_ENTITY_ALERT, {
        text: isHidden
          ? t('enableComment.save.success.text')
          : t('disableComment.save.success.text'),
      });
    }
    return response;
  };

  const getLegalEntityAddressesData = async (
    id: string,
    addressSort?: ISortOptions | null,
  ) => {
    const legalEntityAddressesData = await getLegalEntityAddresses(id, addressSort);
    if (legalEntityAddressesData) {
      setLegalEntityAddress(legalEntityAddressesData);
    } else {
      setLegalEntityAddress([]);
    }
  };

  const getLegalEntityStorageAddressesData = async (id: string) => {
    setLegalEntityStorageAddressLoaded(false);

    const legalEntityAddressesData = await getLegalEntityStorageAddresses(id);
    if (legalEntityAddressesData) {
      setLegalEntityStorageAddress(legalEntityAddressesData);
    } else {
      setLegalEntityStorageAddress([]);
    }

    setLegalEntityStorageAddressLoaded(true);
  };

  const handleSearchLocationCoordsByAddress = async (
    searchParams: ISearchParams,
    successCallback: (p: any) => void,
    errorCallback: () => void,
    isOnline: boolean = true,
  ) =>
    searchLocationCoordsByAddress(
      searchParams,
      (d) => successCallback(d),
      errorCallback,
      isOnline,
    );

  const validateLegalEntityAddress = async (
    id: string,
    data: ILegalEntityAddressFormValues,
  ) => {
    const addresses = await getLegalEntityAddresses(id, null);
    if (addresses) {
      const isValidAddress = !addresses.filter(
        (address) =>
          address.latitude === +data.latitude && address.longitude === +data.longitude,
      ).length;
      if (!isValidAddress) {
        setAlert(ActionTypes.SET_SAME_PAGE_ALERT, {
          variant: EAlertVariants.error,
          text: t('addAddress.save.failure.invalid'),
        });
      }
      return isValidAddress;
    }
    return true;
  };

  const handleCreateAddress = async (data: ILegalEntityAddressFormValues) => {
    const response = await createLegalEntityAddress(data);
    if (response) {
      setAlert(ActionTypes.SET_LEGAL_ENTITY_ALERT, {
        text: t('addAddress.save.success.text'),
      });
    }
    return response;
  };

  const handleEditAddress = async (data: ILegalEntityAddressFormValues, addressId: string) => {
    const response = await updateLegalEntityAddress(data, addressId);

    if (response) {
      await setAlert(ActionTypes.SET_LEGAL_ENTITY_ALERT, {
        text: t('editAddress.save.success.text'),
      });
    }
    return response;
  };

  const handleDeleteAddress = async (id: string, addressId: string) => {
    const response = await deleteLegalEntityAddress(id, addressId);
    if (response) {
      await setAlert(ActionTypes.SET_LEGAL_ENTITY_ALERT, {
        text: t('deleteAddress.save.success.text'),
      });
    }
    return response;
  };

  const handleCreateContact = async (data: ILegalEntityContactFormValues) => {
    const response = await createLegalEntityContact(data);

    if (response) {
      await setAlert(ActionTypes.SET_LEGAL_ENTITY_ALERT, {
        text: t('addContact.save.success.text'),
      });
    }
    return response;
  };

  const handleDeletePreviousNamesSurnames = async (id: string) => {
    const response = await deleteLegalEntityPreviousNamesSurnames(id);
    if (response) {
      await setAlert(ActionTypes.SET_LEGAL_ENTITY_ALERT, {
        text: t('deletePreviousNamesSurnames.save.success.text'),
      });
    }
    return response;
  };

  const handleCreatePreviousNamesSurnames = async (
    data: ILegalEntityPreviousNamesSurnamesFormValues,
  ) => {
    try {
      const response = await createLegalEntityPreviousNamesSurnames(data);

      if (response) {
        await setAlert(ActionTypes.SET_LEGAL_ENTITY_ALERT, {
          text: t('addPreviousNamesSurnames.save.success.text'),
        });
      }

      return response;
    } catch (e: any) {
      setAlert(ActionTypes.SET_SAME_PAGE_ALERT, {
        text: e.response.data?.message,
        variant: EAlertVariants.error,
      });
      return false;
    }
  };
  const handleEditPreviousNamesSurnames = async (
    id: string,
    data: ILegalEntityPreviousNamesSurnamesFormValues,
  ) => {
    try {
      const response = await updateLegalEntityPreviousNamesSurnames(id, data);

      if (response) {
        await setAlert(ActionTypes.SET_LEGAL_ENTITY_ALERT, {
          text: t('editPreviousNamesSurnames.save.success.text'),
        });
      }
      return response;
    } catch (e: any) {
      setAlert(ActionTypes.SET_SAME_PAGE_ALERT, {
        text: e.response.data?.message,
        variant: EAlertVariants.error,
      });
      return false;
    }
  };

  const getLegalEntityPreviouNameSurnameData = async (id: string) => {
    const data = await getLegalEntityPreviousNamesSurnamesDetail(id);
    if (data) {
      setLegalEntityPreviousNamesSurnamesDetail(data);
    } else {
      setLegalEntityPreviousNamesSurnamesDetail(undefined);
    }
  };
  const getLegalEntityLatestContactData = async (id: string) => {
    const data = await getLegalEntityLatestContact(id);
    if (data) {
      setLegalEntityLatestContact(data);
    } else {
      setLegalEntityLatestContact(null);
    }
  };

  const getLegalEntityContactsData = async (id: string, contactSort?: ISortOptions | null) => {
    const legalEntityContactsData = await getLegalEntityContacts(id, contactSort);
    if (legalEntityContactsData) {
      setLegalEntityContacts(legalEntityContactsData);
    } else {
      setLegalEntityContacts([]);
    }
  };

  const getLegalEntityPreviousNamesSurnamesData = async (id: string) => {
    const legalEntityPreviousNamesSurnamesData = await getLegalEntityPreviousNamesSurnames(id);
    if (legalEntityPreviousNamesSurnamesData) {
      setLegalEntityPreviousNamesSurnames(legalEntityPreviousNamesSurnamesData);
    } else {
      setLegalEntityPreviousNamesSurnames([]);
    }
  };

  const handleEditContact = async (legalEntityId: string, data: ILegalEntityContact) => {
    const response = await updateLegalEntityContact(legalEntityId, data);

    if (response) {
      await setAlert(ActionTypes.SET_LEGAL_ENTITY_ALERT, {
        text: t('editContact.save.success.text'),
      });
    }
    return response;
  };

  const handleDeleteContact = async (id: string, contactId: string) => {
    const response = await deleteLegalEntityContact(id, contactId);
    if (response) {
      await setAlert(ActionTypes.SET_LEGAL_ENTITY_ALERT, {
        text: t('deleteContact.save.success.text'),
      });
    }
    return response;
  };

  const handleCreateGroup = async (data: ILegalEntityGroupFormValues) => {
    const response = await createLegalEntityGroup(data);

    if (response) {
      await setAlert(ActionTypes.SET_LEGAL_ENTITY_ALERT, {
        text: t('addGroup.save.success.text'),
      });
      navigateToDetails();
    }

    return response;
  };

  const handleCreateAncillaryGroup = async (data: ILegalEntityAncillaryGroupFormValues) => {
    const response = await createLegalEntityAncillaryGroup(data);

    if (response) {
      await setAlert(ActionTypes.SET_LEGAL_ENTITY_ALERT, {
        text: t('addGroup.save.success.text'),
      });
      navigateToDetails();
    }

    return response;
  };

  const handleEditAncillaryGroup = async (
    lEID: string,
    name: string,
    groupId: string,
    returnLink: string,
  ) => {
    const response = await updateLegalEntityAncillaryGroup(lEID, name, groupId);

    if (response) {
      if (returnLink) {
        navigate(returnLink);
      } else {
        navigateToDetails();
      }
      await setAlert(ActionTypes.SET_LEGAL_ENTITY_ALERT, {
        text: t('editGroup.save.success.text'),
      });
    }

    return response;
  };

  const handleAddAncillaryToGroup = async (
    lEID: string,
    uniqueId: string[],
    groupId: string,
  ) => {
    const response = await addAncillariesToGroup(lEID, uniqueId, groupId);

    if (response) {
      navigateToDetails();
      await setAlert(ActionTypes.SET_LEGAL_ENTITY_ALERT, {
        text: t('editGroup.save.success.text'),
      });
    }

    return response;
  };

  const getAncillaryGroupDetail = async (id: string, groupId: string) => {
    const ancillaryGroupData = await getAncillariesGroupDetail(id, groupId);
    if (ancillaryGroupData) {
      setAncillaryGroupDetail(ancillaryGroupData);
    } else {
      setAncillaryGroupDetail(null);
    }
  };

  const getAncillaryGroupAncillariesDetail = async (groupId: string) => {
    const ancillaryGroupData = await getAncillariesFromGroup(groupId);
    if (ancillaryGroupData) {
      setAncillariesDetail(ancillaryGroupData);
    } else {
      setAncillariesDetail(null);
    }
  };

  const getAncillaryGroupAncillariesSearch = async (
    id: string,
    groupId: string,
    sort: ISortOptions | null,
    currentPage: number = 1,
    perPage: EPerPages = EPerPages.perPage25,
    ancillaryGroupQuery: Partial<ISearchLegalEntityAncillaryGroupFormValues> = {},
  ) => {
    const data = await getLegalEntityAncillaryGroupAncillaries(
      id,
      groupId,
      currentPage,
      perPage,
      { ...ancillaryGroupQuery },
      sort,
    );
    if (data) {
      const { content, ...paginatorData } = data;
      setLegalEntityAncillaryGroupAncillaries(content);
      setPaginatorAncillaryGroupAncillaries(paginatorData);
    } else {
      setLegalEntityAncillaryGroupAncillaries([]);
      setPaginatorAncillaryGroupAncillaries(null);
    }
  };

  const handleDeleteAncillariesGroup = async (id: string, groupId: string) => {
    const response = await deleteLegalEntityAncillariesGroup(id, groupId);
    if (response) {
      await setAlert(ActionTypes.SET_LEGAL_ENTITY_ALERT, {
        text: t('deleteGroup.save.success.text'),
      });
    }
    return response;
  };

  const handleEditGroup = async (data: ILegalEntityEditGroupFormValues, groupId: string) => {
    const response = await updateLegalEntityGroup(data, groupId);

    if (response) {
      navigateToDetails();
      await setAlert(ActionTypes.SET_NEXT_PAGE_ALERT, {
        text: t('editGroup.save.success.text'),
      });
    }

    return response;
  };

  const handleDeleteGroup = async (id: string, groupId: string) => {
    const response = await deleteLegalEntityGroup(id, groupId);
    if (response) {
      await setAlert(ActionTypes.SET_LEGAL_ENTITY_ALERT, {
        text: t('deleteGroup.save.success.text'),
      });
    }
    return response;
  };

  const handleAssignLE = async (data: IAssignLE) => {
    const response = await assignLE(data);

    if (response) {
      await setAlert(ActionTypes.SET_LEGAL_ENTITY_ALERT, {
        text: 'Legal entity has been assigned successfully.',
      });
    }

    return response;
  };

  const handleDeleteAssignedLE = async (data: IAssignLE) => {
    const response = await deleteAssignedLE(data);

    if (response) {
      await setAlert(ActionTypes.SET_LEGAL_ENTITY_ALERT, {
        text: 'The legal entity has been removed from the user.',
      });
    }

    return response;
  };

  const handleRemoveLEGroupFirearm = async (
    leId: string,
    groupId: string,
    firearmId: string,
  ) => {
    const response = await removeLEGroupFirearm(leId, groupId, firearmId);
    if (response) {
      await setAlert(ActionTypes.SET_LEGAL_ENTITY_ALERT, {
        text: t('groupDetails.removeFirearm.success.text'),
      });
    }

    return response;
  };

  const handleRemoveLEGroupAncillary = async (
    leId: string,
    groupId: string,
    ancillaryId: string,
  ) => {
    const response = await removeLEGroupAncillary(leId, groupId, ancillaryId);
    if (response) {
      await setAlert(ActionTypes.SET_LEGAL_ENTITY_ALERT, {
        text: t('groupDetails.removeAncillary.success.text'),
      });
    }

    return response;
  };

  const handleCreateLEGroupFirearm = async (
    leId: string,
    groupId: string,
    firearmIds: string[],
  ) => {
    const response = await createLEGroupFirearm(leId, groupId, firearmIds);
    if (response) {
      navigate(
        `${ERouteLinks.ViewLegalEntityGroup.replace(':id', leId).replace(
          ':groupId',
          groupId,
        )}?type=${type}`,
      );
      await setAlert(ActionTypes.SET_NEXT_PAGE_ALERT, {
        text: t('firearmGroup.addFirearm.success.message'),
      });
    }

    return response;
  };

  const getTrueKeys = (obj: { [key: string]: boolean }): string[] =>
    Object.keys(obj).filter((key) => obj[key]);

  const handleCreateWeaponLicence = async (
    licence: ILegalEntityLicenceFormValues,
    // eslint-disable-next-line @typescript-eslint/no-shadow
    owner: IOwner,
    backLink: string,
  ) => {
    try {
      const goodReasonDictionaryIds: string[] | null = licence?.conditions?.goodReasonUniqueIds
        ? getTrueKeys(licence?.conditions?.goodReasonUniqueIds)
        : null;

      const data: ILegalEntityWeaponLicence = {
        ...licence,
        general: {
          ...licence.general,
          startDate: formatOnlyDateToRequest(licence.general.startDate),
          expiryDate: licence.general.expiryDate
            ? formatOnlyDateToRequest(licence.general.expiryDate)
            : null,
        },
        conditions: {
          ...licence.conditions,
          goodReasonUniqueIds: goodReasonDictionaryIds,
        },
        owner,
      };

      const files = licence.documents.map((item) => item.file);

      const response = await createWeaponLicence(data, files);
      if (response) {
        navigate(backLink.replace(':licenceId', response.uniqueId));
        await setAlert(ActionTypes.SET_NEXT_PAGE_ALERT, {
          text: t('legalEntity.licence.success.message'),
        });
      }

      return response;
    } catch (e: any) {
      await setAlert(ActionTypes.SET_SAME_PAGE_ALERT, {
        text: e.response.data.message,
        variant: EAlertVariants.error,
      });
      return null;
    }
  };
  const handleVaryLicence = async (
    licenceData: ILegalEntityLicenceVaryFormValues,
    shouldUpdateScheduled: boolean,
    isLimitSchedule: boolean,
    // eslint-disable-next-line @typescript-eslint/no-shadow
    owner: IOwner,
    backLink: () => void,
    licenceId: string,
  ) => {
    const { uniqueId, weaponLicenceTemplateUniqueId, ...licence } = licenceData;
    const goodReasonDictionaryIds: string[] | null = licence?.conditions?.goodReasonUniqueIds
      ? getTrueKeys(licence?.conditions?.goodReasonUniqueIds)
      : null;

    const data: ILegalEntityWeaponLicenceVary = {
      ...licence,
      conditions: {
        ...licence.conditions,
        goodReasonUniqueIds: goodReasonDictionaryIds,
      },
      owner,
      shouldUpdateScheduled,
    };

    const files = licence.document.documents.map((item) => item.file);

    try {
      const result = await varyWeaponLicence(data, files, licenceId as string);
      if (result.status === 204) {
        backLink();
        await setAlert(ActionTypes.SET_NEXT_PAGE_ALERT, {
          text:
            isLimitSchedule && shouldUpdateScheduled
              ? t('legalEntity.licence.vary.scheduled.message')
              : t('legalEntity.licence.vary.success.message'),
        });
      }
      return result;
    } catch (e: any) {
      await setAlert(ActionTypes.SET_SAME_PAGE_ALERT, {
        text: e.response.data.message,
        variant: EAlertVariants.error,
      });
      return null;
    }
  };

  const handleRenewLicence = async (
    licenceData: ILegalEntityLicenceRenewFormValues,
    // eslint-disable-next-line @typescript-eslint/no-shadow
    owner: IOwner,
    backLink: (licenceIdToNavigate: string) => void,
    licenceId: string,
  ) => {
    const { uniqueId, weaponLicenceTemplateUniqueId, ...licence } = licenceData;
    const goodReasonDictionaryIds: string[] | null = licence?.conditions?.goodReasonUniqueIds
      ? getTrueKeys(licence?.conditions?.goodReasonUniqueIds)
      : null;

    const data: ILegalEntityWeaponLicenceRenew = {
      ...licence,
      conditions: {
        ...licence.conditions,
        goodReasonUniqueIds: goodReasonDictionaryIds,
      },
      owner,
    };

    const files = licence.documents.map((item) => item.file);

    try {
      const result = await renewWeaponLicence(data, files, licenceId as string);
      if (result.status === 200) {
        await setAlert(ActionTypes.SET_NEXT_PAGE_ALERT, {
          text: t('legalEntity.licence.renew.success.message'),
        });
        backLink(result.data.uniqueId);
      }
      return result;
    } catch (e: any) {
      await setAlert(ActionTypes.SET_SAME_PAGE_ALERT, {
        text: e.response.data.message,
        variant: EAlertVariants.error,
      });
      return null;
    }
  };

  const handleCreateInitialTransaction = async (body: IInitialTransaction) => {
    await createInitialTransaction(body);
  };

  const getLegalEntityForPreset = async (id: string, LEType: ESelectLE) => {
    const result = await Promise.allSettled([getOrgLegalEntity(id), getLegalEntity(id)]);
    let option: IFormElementOptionProp;

    result.map((promise) => {
      if (promise.status === 'fulfilled') {
        if (promise?.value) {
          option = {
            label:
              ('organizationName' in promise.value ? promise.value.organizationName : '') ||
              ('firstName' in promise.value && 'lastName' in promise.value
                ? `${promise.value.firstName} ${promise.value.lastName}`
                : ''),
            value: id,
          };
          if (LEType === ESelectLE.owner) {
            setOwner(option);
          } else {
            setKeeper(option);
          }
        }
      }
      return false;
    });
  };

  const getCustomField = async (
    objectType: ECustomFieldObjectType,
    filterFunc?: (arg: ICustomFieldByObjectType) => boolean,
  ) => {
    setCustomFieldsLoaded(false);
    const result = await getCustomFieldByObjectType(objectType);
    if (result) {
      if (objectType === ECustomFieldObjectType.LE_INDIVIDUAL) {
        setCustomFieldsILE(filterFunc ? result.content.filter(filterFunc) : result.content);
      } else if (objectType === ECustomFieldObjectType.LE_ORGANIZATION) {
        setCustomFieldsOLE(filterFunc ? result.content.filter(filterFunc) : result.content);
      } else if (objectType === ECustomFieldObjectType.FIREARM) {
        setCustomFieldsFirearms(
          filterFunc ? result.content.filter(filterFunc) : result.content,
        );
      } else if (
        [
          ECustomFieldObjectType.AN_ACCESSORY,
          ECustomFieldObjectType.AN_AMMUNITION,
          ECustomFieldObjectType.AN_COMPONENT,
        ].includes(objectType)
      ) {
        setCustomFieldsAncillaries(
          filterFunc ? result.content.filter(filterFunc) : result.content,
        );
      } else if (objectType === ECustomFieldObjectType.LICENCE) {
        setCustomFieldsLicence(
          filterFunc ? result.content.filter(filterFunc) : result.content,
        );
      }
      setCustomFieldsLoaded(true);
    }
  };

  const getCustomFields = async (
    objectTypes: ECustomFieldObjectType[],
    filterFunc?: (arg: ICustomFieldByObjectType) => boolean,
  ) => {
    setCustomFieldsLoaded(false);

    await Promise.all(
      objectTypes.map(async (objectType) => {
        const result = await getCustomFieldByObjectType(objectType);
        if (result) {
          if (objectType === ECustomFieldObjectType.LE_INDIVIDUAL) {
            setCustomFieldsILE(
              filterFunc ? result.content.filter(filterFunc) : result.content,
            );
          } else if (objectType === ECustomFieldObjectType.LE_ORGANIZATION) {
            setCustomFieldsOLE(
              filterFunc ? result.content.filter(filterFunc) : result.content,
            );
          } else if (objectType === ECustomFieldObjectType.FIREARM) {
            setCustomFieldsFirearms(
              filterFunc ? result.content.filter(filterFunc) : result.content,
            );
          } else if (
            [
              ECustomFieldObjectType.AN_ACCESSORY,
              ECustomFieldObjectType.AN_AMMUNITION,
              ECustomFieldObjectType.AN_COMPONENT,
            ].includes(objectType)
          ) {
            setCustomFieldsAncillaries(
              filterFunc ? result.content.filter(filterFunc) : result.content,
            );
          } else if (objectType === ECustomFieldObjectType.LICENCE) {
            setCustomFieldsLicence(
              filterFunc ? result.content.filter(filterFunc) : result.content,
            );
          }
        }
      }),
    );

    setCustomFieldsLoaded(true);
  };

  const getLicencesTemplatesForLE = async (
    weaponLicenceName: string,
    weaponLicenceCode: string,
    id: string,
    currentPage: number = 1,
    perPage: EPerPages = EPerPages.perPage25,
    sort?: ISortOptions | null,
  ) => {
    const body = {
      name: weaponLicenceName,
      code: weaponLicenceCode,
      legalUniqueId: id,
    };
    const data = await getLicenceTemplatesForLE(body, currentPage, perPage, sort);
    if (data) {
      const { content, ...paginatorData } = data;
      setLicencesTemplatesForLE(content);
      setPaginatorLicenceTemplateLE(paginatorData);
    } else {
      setLicencesTemplatesForLE([]);
      setPaginatorLicenceTemplateLE(null);
    }
  };

  const getLegalEntityLicenceAuthoritiesData = async (id: string) => {
    const legalEntityLicenceAuthoritiesData = await getLegalEntityLicenceAuthorities(id);

    if (legalEntityLicenceAuthoritiesData) {
      setLegalEntityLicenceAuthorities(legalEntityLicenceAuthoritiesData);
    } else {
      setLegalEntityLicenceAuthorities(null);
    }
  };

  const getLegalEntityLicencesData = async (
    page: number,
    size: EPerPages,
    body: ILicenceSearchForLeParameters,
    licenceSort?: ISortOptions | null,
  ) => {
    const legalEntityLicencesData = await getLegalEntityLicences(
      page,
      size,
      body,
      licenceSort,
    );
    if (legalEntityLicencesData) {
      const { content, ...paginatorData } = legalEntityLicencesData;
      setLegalEntityLicences(content);
      setPaginatorLicences(paginatorData);
    } else {
      setLegalEntityLicences([]);
      setPaginatorLicences(null);
    }
  };
  const getLegalEntityCasesData = async (
    id: string,
    page: number,
    size: EPerPages,
    body: ICaseSearchForLe,
    sort?: ISortOptions | null,
  ) => {
    const caseData = await getLegalEntityCases(id, page, size, body, sort);
    if (caseData) {
      const { content, ...paginatorData } = caseData;
      setLegalEntityCases(content);
      setPaginatorCases(paginatorData);
    } else {
      setLegalEntityCases([]);
      setPaginatorCases(null);
    }
  };

  const getLicenceHasSuspendedParentData = async (id: string) => {
    const licenceHasSuspendedParentData = await getLicenceHasSuspendedParent(id);
    if (licenceHasSuspendedParentData) {
      setLicenceHasSuspendedParent(licenceHasSuspendedParentData);
    } else {
      setLicenceHasSuspendedParent(null);
    }
  };

  const getLegalEntityLicenceDetailsData = async (id: string) => {
    const legalEntityLicencesData = await getLegalEntityLicenceDetails(id);
    if (legalEntityLicencesData) {
      setLegalEntityLicenceDetails(legalEntityLicencesData);
    } else {
      setLegalEntityLicenceDetails(null);
    }
  };

  const getLicenceMismatchingLegalEntityData = async (id: string) => {
    const data = await getLicenceMismatchingLegalEntity(id);
    if (data) {
      setLicenceMismatchingLegalEntity(data);
    } else {
      setLicenceMismatchingLegalEntity(null);
    }
  };

  const getLicenceAttachmentsData = async (weaponLicenceUniqueId: string) => {
    const attachmentsData = await getLicenceAttachments(weaponLicenceUniqueId);
    if (attachmentsData) {
      setLicenceAttachments(attachmentsData);
    } else {
      setLicenceAttachments(null);
    }
  };

  const getLicenceHistoryData = async (licenceUniqueId: string) => {
    const historyData = await getLicenceHistory(licenceUniqueId);
    if (historyData) {
      setLicenceHistory(historyData);
    } else {
      setLicenceHistory(null);
    }
  };

  const getLicenceAttachmentFile = async (
    weaponLicenceUniqueId: string,
    attachmentUniqueId: string,
    getFIleType: 'download' | 'view',
  ) => {
    const attachmentData = await getLicenceAttachmentFileData(
      weaponLicenceUniqueId,
      attachmentUniqueId,
      getFIleType,
    );
    return attachmentData;
  };

  const getLicenceWeaponData = async (
    licenceId: string,
  ): Promise<ILicenceFirearmsResponse[]> => {
    const data = await getLicenceWeapon(licenceId);
    const normalizedData = data || [];
    setLicenceWeapon(normalizedData);
    return normalizedData;
  };

  const handleRevokeWeaponLicence = async (uniqueId: string, body: ILicenceActionRequest) => {
    try {
      const response = await revokeWeaponLicence(uniqueId, body);
      if (response) {
        setAlert(ActionTypes.SET_SAME_PAGE_ALERT, {
          text: t('revokeLicence.success.text'),
          variant: EAlertVariants.success,
        });
      }
      return response;
    } catch (e: any) {
      setAlert(ActionTypes.SET_SAME_PAGE_ALERT, {
        text: e.response?.data?.message || t('revokeLicence.error.text'),
        variant: EAlertVariants.error,
      });
      return false;
    }
  };

  const handleCancelWeaponLicence = async (uniqueId: string, body: ILicenceActionRequest) => {
    try {
      const response = await cancelWeaponLicence(uniqueId, body);
      if (response) {
        setAlert(ActionTypes.SET_SAME_PAGE_ALERT, {
          text: t('cancelLicence.success.text'),
          variant: EAlertVariants.success,
        });
      }
      return response;
    } catch (e: any) {
      setAlert(ActionTypes.SET_SAME_PAGE_ALERT, {
        text: e.response?.data?.message || t('cancelLicence.error.text'),
        variant: EAlertVariants.error,
      });
      return false;
    }
  };

  const handleSuspendWeaponLicence = async (uniqueId: string, body: ILicenceActionRequest) => {
    try {
      const response = await suspendWeaponLicence(uniqueId, body);
      if (response) {
        setAlert(ActionTypes.SET_SAME_PAGE_ALERT, {
          text: t('suspendLicence.success.text'),
          variant: EAlertVariants.success,
        });
      }
      return response;
    } catch (e: any) {
      setAlert(ActionTypes.SET_SAME_PAGE_ALERT, {
        text: e.response?.data?.message || t('suspendLicence.error.text'),
        variant: EAlertVariants.error,
      });
      return false;
    }
  };

  const handleSurrenderWeaponLicence = async (
    uniqueId: string,
    body: ILicenceActionRequest,
  ) => {
    try {
      const response = await surrenderWeaponLicence(uniqueId, body);
      if (response) {
        setAlert(ActionTypes.SET_SAME_PAGE_ALERT, {
          text: t('surrenderLicence.success.text'),
          variant: EAlertVariants.success,
        });
      }
      return response;
    } catch (e: any) {
      setAlert(ActionTypes.SET_SAME_PAGE_ALERT, {
        text: e.response?.data?.message || t('surrenderLicence.error.text'),
        variant: EAlertVariants.error,
      });
      return false;
    }
  };

  const handleReactivateWeaponLicence = async (
    uniqueId: string,
    body: ILicenceActionRequest,
  ) => {
    try {
      const response = await reactivateWeaponLicence(uniqueId, body);
      if (response) {
        setAlert(ActionTypes.SET_SAME_PAGE_ALERT, {
          text: t('reactivateLicence.success.text'),
          variant: EAlertVariants.success,
        });
      }
      return response;
    } catch (e: any) {
      setAlert(ActionTypes.SET_SAME_PAGE_ALERT, {
        text: e.response?.data?.message || t('reactivateLicence.error.text'),
        variant: EAlertVariants.error,
      });
      return false;
    }
  };

  const getLegalEntityAddressDetailsData = async (id: string, addressId: string) => {
    const data = await getLegalEntityAddressDetail(id, addressId);
    if (data) {
      setLegalEntityAddressDetails(data);
    } else {
      setLegalEntityAddressDetails(undefined);
    }
  };

  const getScheduledLicenceData = async (
    id: string,
  ): Promise<ILicenceScheduledResponse | null> => {
    const data = await weaponLicenceScheduledData(id);
    if (data) {
      return data;
    }
    return null;
  };

  const deactivateLegalEntity = async (
    id: string,
    type: string | ELegalEntityTypes,
    data: IFormDeactivationLEValues,
  ) => {
    try {
      let response;
      if (type === ELegalEntityTypes.individual) {
        response = await deactivateIndividualLegalEntity(id, data);
      } else {
        response = await deactivateOrganizationLegalEntity(id, data);
      }

      setAlert(ActionTypes.SET_LEGAL_ENTITY_ACTIVATE_ALERT, {
        text: t('legalEntityDetails.deactivateLegalEntity.success.text'),
      });
      return true;
    } catch (e: any) {
      if (e.response.status === 400 || e.response.status === 409) {
        setAlert(ActionTypes.SET_LEGAL_ENTITY_ACTIVATE_ALERT, {
          text: e.response.data.message,
          variant: EAlertVariants.warning,
        });
      }
      return false;
    }
  };
  const activateLegalEntity = async (
    id: string,
    type: string | ELegalEntityTypes,
    data: IFormActivationLEValues,
  ) => {
    try {
      let response;
      if (type === ELegalEntityTypes.individual) {
        response = await activateIndividualLegalEntity(id, data);
      } else {
        response = await activateOrganizationLegalEntity(id, data);
      }

      setAlert(ActionTypes.SET_LEGAL_ENTITY_ACTIVATE_ALERT, {
        text: t('legalEntityDetails.activateLegalEntity.success.text'),
      });
      return true;
    } catch (e: any) {
      if (e.response.status === 400 || e.response.status === 409) {
        setAlert(ActionTypes.SET_LEGAL_ENTITY_ACTIVATE_ALERT, {
          text: e.response.data.message,
          variant: EAlertVariants.warning,
        });
      }
      return false;
    }
  };

  return {
    loadDictionaries,
    gender,
    organisationStateType,
    organisationCivilianType,
    organisationMilitaryType,
    organisationPoliceType,
    organisationCategory,
    getOrganisationCategory,
    legalVisibility,
    legalEntityPrefix,
    civilianPrefix,
    militaryPrefix,
    policePrefix,
    make,
    model,
    state,
    caliber,
    nationality,
    identificationDocumentType,
    legalStatus,
    legalIndividualDeactivationReason,
    legalOrganisationDeactivationReason,
    artAncillaryOptions,
    artComponentType,
    artAccessoryType,
    artAmmunitionType,
    paginatorILE,
    paginatorOLE,
    paginatorLEF,
    paginatorLEG,
    paginatorLEGF,
    phoneCode,
    handleCreate,
    getLegalEntitiesData,
    legalEntities,
    getLegalEntityFirearmsData,
    legalEntityFirearms,
    getLegalEntityGroupsData,
    legalEntityGroups,
    legalEntityGroupFirearms,
    getLegalEntityGroupFirearmsData,
    handleEdit,
    handleDelete,
    getOrganizationLegalEntitiesData,
    organizationLegalEntity,
    navigateToList,
    handleOrgLECreate,
    handleOrgLEEdit,
    handleOrgLEDelete,
    handleCreateComment,
    navigateToDetails,
    handleDeleteComment,
    getLegalEntityAddressesData,
    getLegalEntityStorageAddressesData,
    legalEntityStorageAddressLoaded,
    legalEntityAddress,
    legalEntityStorageAddress,
    region,
    country,
    handleCreateAddress,
    handleSearchLocationCoordsByAddress,
    handleEditAddress,
    handleDeleteAddress,
    getLegalEntityContactsData,
    legalEntityContacts,
    getLegalEntityPreviousNamesSurnamesData,
    legalEntityPreviousNamesSurnames,
    legalEntityPreviousNamesSurnamesDetail,
    handleCreatePreviousNamesSurnames,
    handleEditPreviousNamesSurnames,
    getLegalEntityPreviouNameSurnameData,
    handleDeletePreviousNamesSurnames,
    getLegalEntityLatestContactData,
    legalEntityLatestContact,
    handleCreateContact,
    handleEditContact,
    handleDeleteContact,
    addressType,
    legalEntityComments,
    paginatorLEComments,
    getLegalEntityCommentsData,
    getLegalEntityGroupData,
    legalEntityGroup,
    handleCreateGroup,
    handleEditGroup,
    handleDeleteGroup,
    handleAssignLE,
    handleDeleteAssignedLE,
    legality,
    manufacturer,
    handleRemoveLEGroupFirearm,
    handleCreateLEGroupFirearm,
    firearmAction,
    firearmType,
    level,
    manufacturerCountry,
    transactionType,
    legalClassification,
    handleCreateInitialTransaction,
    getLegalEntityForPreset,
    owner,
    keeper,
    countryAll,
    getCustomField,
    getCustomFields,
    customFieldsILE,
    customFieldsOLE,
    customFieldsFirearms,
    customFieldsAncillaries,
    customFieldsLicence,
    validateLegalEntityAddress,
    customFieldsLoaded,
    getLegalEntityAncillariesData,
    legalEntityAncillaries,
    legalEntityAncillaryGroups,
    paginatorAncillaries,
    paginatorAncillaryGroups,
    getLegalEntityAncillaryGroupsData,
    getLegalEntityAttachmentsData,
    legalEntityAttachments,
    paginatorLegalAttachments,
    handleCreateAncillaryGroup,
    handleEditAncillaryGroup,
    handleAddAncillaryToGroup,
    getAncillaryGroupDetail,
    ancillaryGroupDetail,
    handleDeleteAncillariesGroup,
    getAncillaryGroupAncillariesSearch,
    legalEntityAncillaryGroupAncillaries,
    paginatorAncillaryGroupAncillaries,
    handleRemoveLEGroupAncillary,
    getAncillaryGrouptransactionType,
    ancillaryGrouptransactionType,
    artAccessoryManufacturerFlashEliminator,
    artAccessoryManufacturerLaserLightModule,
    artAccessoryManufacturerMagazine,
    artAccessoryManufacturerOpticalSight,
    artAccessoryManufacturerSuppressor,
    artAmmunitionManufacturer,
    artComponentManufacturer,
    getAncillaryGroupAncillariesDetail,
    ancillariesDetail,
    transactionTypeValidate,
    transactionTypeIsValid,
    navigateToGroupDetails,
    weaponLicencingAuthority,
    getLicencesTemplatesForLE,
    licencesTemplatesForLE,
    paginatorLicenceTemplateLE,
    handleCreateWeaponLicence,
    handleVaryLicence,
    handleRenewLicence,
    getLegalEntityLicencesData,
    legalEntityLicences,
    paginatorLicences,
    getLegalEntityLicenceDetailsData,
    legalEntityLicenceDetails,
    getLicenceAttachmentsData,
    licenceAttachments,
    getLicenceHistoryData,
    licenceHistory,
    getLicenceAttachmentFile,
    getLicenceWeaponData,
    licenceWeapon,
    handleRevokeWeaponLicence,
    handleCancelWeaponLicence,
    handleSuspendWeaponLicence,
    handleSurrenderWeaponLicence,
    handleReactivateWeaponLicence,
    legalEntityAddressDetails,
    getLegalEntityAddressDetailsData,
    getScheduledLicenceData,
    legalEntityLicenceAuthorities,
    getLegalEntityLicenceAuthoritiesData,
    licenceMismatchingLegalEntity,
    getLicenceMismatchingLegalEntityData,
    licenceHasSuspendedParent,
    getLicenceHasSuspendedParentData,
    deactivateLegalEntity,
    activateLegalEntity,
    getLegalEntityCasesData,
    legalEntityCases,
    paginatorCases,
  };
};
